function addPers() {
  const container = document.querySelector('.pers_container');
  const inputs = container.querySelectorAll('input');
  
  if (inputs.length < 5) {
    const div = document.createElement('div');
    const p = document.createElement('p');
    const input = document.createElement('input');
    
    p.textContent = `Personalización ${inputs.length + 1}`;
    input.type = 'text';
    input.id = `pers_input_${inputs.length + 1}`;
    
    div.appendChild(p);
    div.appendChild(input);
    container.appendChild(div);
  } else {
    alert('No puedes añadir más de 5 personalizaciones.');
  }
}